import React from 'react';


function Education() {
    return (  
        <div className='container'>
            <div className='row p-5 mb-5'>
                <div className='col-6 p-5'>
                        <img src='media/image/education.svg' style={{width:"70%"}}/>
                </div>
                <div className='col-6 p-5'>
                    <h1 className='fs-2'>Free and open market education</h1>
                    <p className='mt-3'>Varsity, the largest online stock market education book in the world covering everything from the basics to advanced trading.</p>
                     <a href='' style={{textDecoration:"none"}}>Varsity <i class="fa fa-long-arrow-right" aria-hidden="true"></i></a>
                     <br></br>
                      <p className='mt-3'>TradingQ&A, the most active trading and investment community in India for all your market related queries.</p>
                     <a href='' style={{textDecoration:"none"}}>TradingQ&A  <i class="fa fa-long-arrow-right" aria-hidden="true"></i></a>
                </div>
            </div>
        </div>
    );
}

export default Education;